import getFilterWithCol from '../../helpers/getFilterWithCol';

import Types from '../../modules/types';
import {
  filterSortCreatedUpdatedName as filterSort,
} from '../../components/common';

export const filterSearch = ['FilterField', {
  id: 'search',
  label: null, // 'ID',
  section: 'top',
  buildQuery: (value, builder) => {
    if (value?.length) {
      const valueRegex = Types.getSafeSearchRegex(value);
      builder.add(
        'where',
        {
          OR: ['name', 'email'].map(key => ({
            [key]: { REGEX: valueRegex, OPTIONS: 'i' },
          })),
        },
      );
    }
  },
  getValueForField: value => value || '',
  getValueForQuery: (value) => {
    value = !value
    ? undefined
    : value.target
    ? value.target.value
    : value;
    return !value || !value.length
    ? undefined
    : value;
  },
  field: ['FieldText', {
    name: 'search',
    placeholder: 'Pretraga',
  }],
}];

export const filterActive = ['FilterField', {
  id: 'available',
  label: null,
  section: 'top',
  VALUES_MAP: {
    any: null,
    active: { active: { EQ: true } },
    inactive: { active: { EQ: false } },
  },
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
    ? builder.add('where', { ...filter.VALUES_MAP[value] })
    : null
  ),
  getValueForField: value => (
    value && value.length
    ? value
    : 'any'
  ),
  field: ['FieldSelect', {
    name: 'active',
    placeholder: 'Active',
    prepareValueForInput: value => (value ? value : 'any'),
    initialValue: 'any',
    choices: [{
      label: 'Svi',
      value: 'any',
    }, {
      label: 'Aktivni',
      value: 'active',
    }, {
      label: 'Neaktivni',
      value: 'inactive',
    }],
  }],
}];

export const filterPagination = ['FilterPagination', {
  id: 'pagination',
  section: 'bottom',
}];

export const filterNotSignups = ['FilterHidden', {
  id: 'nonSignupUsers',
  section: 'bottom',
  build: builder => builder.add('where', { signup: { NE: true } }),
}];

export const filterAdmins = ['FilterHidden', {
  id: 'admins',
  section: 'bottom',
  build: builder => builder.add('where', { role: { EQ: 'ADMIN' } }),
}];

export const ADMIN_ALL = [
  ...[
    [filterSearch, 8],
    [filterActive, 8],
    [filterSort, 8],
    // [filterRole, 8],
  ].map(args => getFilterWithCol(...args)),

  filterPagination,
  filterNotSignups,
  filterAdmins,
];
